/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".btn-wp-primary[_ngcontent-%COMP%]{color:#ed1976!important;background-color:transparent!important;border-color:#ed1976!important}.btn-wp-primary[_ngcontent-%COMP%]:hover, btn-pw-primary[_ngcontent-%COMP%]{color:#fff!important;background-color:#ed1976!important;border-color:#ed1976!important}.btn-pw-primary[_ngcontent-%COMP%]:hover{color:#ed1976!important;background-color:transparent!important;border-color:#ed1976!important}main[_ngcontent-%COMP%]{height:calc(100% - 344px)}.font62[_ngcontent-%COMP%]{font-size:62px!important}.full-wraper[_ngcontent-%COMP%]{height:100vh!important;width:100%;padding:0;margin:0}"];
export { styles as styles };

